// mixin/dateMixin.js
import dayjs from 'dayjs'

export default {
  methods: {
    $dateFormat (date, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!date) return '-'
      return dayjs(date).format(format)
    },

    $dateFormatShort (date) {
      if (!date) return '-'
      return this.$dateFormat(date, 'YYYY-MM-DD')
    },

    $dateFormatTime (date) {
      if (!date) return '-'
      return this.$dateFormat(date, 'HH:mm:ss')
    },

    $dateFormatMonth (date) {
      if (!date) return '-'
      return this.$dateFormat(date, 'YYYY-MM')
    },

    $dateFormatYear (date) {
      if (!date) return '-'
      return this.$dateFormat(date, 'YYYY')
    },

    $dateFormatRelative (date) {
      if (!date) return '-'
      return dayjs(date).fromNow()
    },

    $dateFormatCustom (date, format) {
      if (!date) return '-'
      return this.$dateFormat(date, format)
    }
  }
}
